import(/* webpackMode: "eager", webpackExports: ["EditorialLayout"] */ "/vercel/path0/apps/web/src/app/[locale]/(editorial)/EditorialLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/[locale]/PageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DefaultLayout"] */ "/vercel/path0/apps/web/src/app/DefaultLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
